import styled from "@emotion/styled/macro";
import { tokens, Typography } from "@sunrun/experience-ui-components";

type OfferReviewSimplifiedPaymentDisclaimerProps = {
  disclaimer: string;
  offerExpires?: string;
  isMobile: boolean;
};

const OfferReviewSimplifiedPaymentDisclaimer = ({
  disclaimer,
  offerExpires,
  isMobile,
}: OfferReviewSimplifiedPaymentDisclaimerProps) => (
  <PaymentDisclaimerRow data-testid="offer-review-simplified-payment-disclaimer">
    <PaymentDisclaimerText size={12} color={tokens.BRAND_MEDIUM_BLUE}>
      {disclaimer}

      {offerExpires ? (
        <ValidUntilText>
          Valid until
          {new Date(offerExpires).toLocaleDateString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
          })}
        </ValidUntilText>
      ) : null}
    </PaymentDisclaimerText>
  </PaymentDisclaimerRow>
);

const PaymentDisclaimerRow = styled.div`
  display: flex;
  flex-direction: row;
  width: fit-content;
  margin-left: auto;
  margin-right: 20px;
`;

const PaymentDisclaimerText = styled(Typography)`
  line-height: 140%;
`;

const ValidUntilText = styled.span`
  padding-left: 8px;
`;
export { OfferReviewSimplifiedPaymentDisclaimer };
